import React, { useState, useEffect } from 'react';
import './App.css';
import LoginPage from './pages/LoginPage';
import LocationsPage from './pages/LocationsPage';
import FilesPage from './pages/FilesPage';
import StatsPage from './pages/StatsPage';
import apiClient from './api/apiClient';

export default function App() {
  const [view, setView] = useState('login');
  const [user, setUser] = useState(null);
  const [locations, setLocations] = useState([]);
  const [selectedLocation, setSelectedLocation] = useState(null);
  const [files, setFiles] = useState([]);
  const [activityLogs, setActivityLogs] = useState([]);
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState('');

  useEffect(() => {
    const token = localStorage.getItem('admin_token');
    if (token) {
      loadLocations();
      setView('locations');
    }
  }, []);

  const handleLogin = async (username, password) => {
    setLoading(true);
    const result = await apiClient.login(username, password);
    setLoading(false);
    if (result.success) {
      localStorage.setItem('admin_token', result.data.token);
      setUser(result.data.user);
      await loadLocations();
      setView('locations');
    } else {
      setMessage(`Error: ${result.error}`);
    }
  };

  const loadLocations = async () => {
    setLoading(true);
    const result = await apiClient.getLocations();
    setLoading(false);
    if (result.success) {
      setLocations(result.data);
      generateActivityLogs(result.data);
    } else {
      setMessage(`Error: ${result.error}`);
    }
  };

  const generateActivityLogs = (locs) => {
    const logs = [];
    locs.forEach((loc, idx) => {
      logs.push({
        id: idx,
        action: 'Ubicación creada',
        location: loc.name,
        timestamp: new Date(loc.created_at).toLocaleString('es-MX')
      });
    });
    setActivityLogs(logs);
  };

  const handleSelectLocation = async (location) => {
    setSelectedLocation(location);
    await loadFiles(location.id);
    setView('files');
  };

  const loadFiles = async (locationId) => {
    setLoading(true);
    const result = await apiClient.getFilesAsAdmin(locationId);
    setLoading(false);
    if (result.success) {
      setFiles(result.data || []);
    } else {
      setMessage(`Error: ${result.error}`);
    }
  };

  const handleLogout = () => {
    localStorage.removeItem('admin_token');
    setUser(null);
    setLocations([]);
    setSelectedLocation(null);
    setFiles([]);
    setActivityLogs([]);
    setView('login');
  };

  const handleBack = () => {
    setSelectedLocation(null);
    setFiles([]);
    setView('locations');
  };

  return (
    <div style={{display:'flex',flexDirection:'column',minHeight:'100vh',background:'#fff'}}>
      <header style={{background:'linear-gradient(135deg, #1e3c72 0%, #2a5298 100%)',color:'white',padding:'1.5rem'}}>
        <div style={{maxWidth:'1400px',margin:'0 auto',display:'flex',justifyContent:'space-between',alignItems:'center'}}>
          <h1>📊 Admin Dashboard - File Marca One</h1>
          {user && (
            <div style={{display:'flex',alignItems:'center',gap:'1.5rem'}}>
              <span>👤 {user.username}</span>
              <button onClick={handleLogout} style={{background:'rgba(255,255,255,0.2)',border:'1px solid rgba(255,255,255,0.3)',color:'white',padding:'0.6rem 1.2rem',borderRadius:'4px',cursor:'pointer'}}>Salir</button>
            </div>
          )}
        </div>
      </header>

      {user && (
        <nav style={{background:'#f8f9fa',borderBottom:'1px solid #e9ecef',padding:'1rem'}}>
          <div style={{maxWidth:'1400px',margin:'0 auto',display:'flex',gap:'1rem'}}>
            <button onClick={() => setView('locations')} style={{background:view==='locations'?'#2a5298':'white',color:view==='locations'?'white':'#495057',border:'1px solid #dee2e6',padding:'0.7rem 1.5rem',borderRadius:'6px',cursor:'pointer',fontWeight:'500'}}>📁 Ubicaciones</button>
            <button onClick={() => setView('stats')} style={{background:view==='stats'?'#2a5298':'white',color:view==='stats'?'white':'#495057',border:'1px solid #dee2e6',padding:'0.7rem 1.5rem',borderRadius:'6px',cursor:'pointer',fontWeight:'500'}}>📊 Estadísticas</button>
          </div>
        </nav>
      )}

      <main style={{flex:1,maxWidth:'1400px',width:'100%',margin:'0 auto',padding:'2rem'}}>
        {message && (
          <div style={{padding:'1rem',borderRadius:'6px',marginBottom:'1.5rem',background:message.includes('Error')?'#f8d7da':'#d4edda',color:message.includes('Error')?'#721c24':'#155724'}}>
            {message}
            <button onClick={()=>setMessage('')} style={{background:'none',border:'none',float:'right',cursor:'pointer'}}>×</button>
          </div>
        )}
        {loading && <div style={{textAlign:'center',padding:'3rem',color:'#2a5298'}}>Cargando...</div>}
        {view === 'login' && <LoginPage onLogin={handleLogin} loading={loading} />}
        {view === 'locations' && <LocationsPage locations={locations} onSelectLocation={handleSelectLocation} onRefresh={loadLocations} loading={loading} />}
        {view === 'files' && selectedLocation && <FilesPage location={selectedLocation} files={files} onBack={handleBack} loading={loading} onFilesChanged={() => loadFiles(selectedLocation.id)} />}
        {view === 'stats' && <StatsPage locations={locations} activityLogs={activityLogs} />}
      </main>
    </div>
  );
}
